// Ramp-priced plans whose first billing cycle is $0 in Recurly (ramp interval 1
// = $0, interval 2+ = the catalog price). The catalog list API only returns the
// recurring price, so when `cc/order/preview-payment` can't run (e.g. "Billing
// info missing on account") the client-side Due Today fallback must not charge
// the recurring price up front.
//
// Keep in sync with RAMP_PRICING_SECOND_INTERVAL_PLAN_CODES in
// ooe-service/services/cc-order-service.js.
const FIRST_CYCLE_FREE_RAMP_CODES = [
  'addon-5-listrefrsh-m2m',
  'addon-5-stratcontent-m2m',
]

export function isFirstCycleFreeRampPlan(productCode) {
  return FIRST_CYCLE_FREE_RAMP_CODES.includes(productCode)
}
